<template>
  <form action="" @submit.prevent="sendArticle()">
    <div class="pa-4 text-center">
    <v-dialog
      v-model="dialog"
      max-width="600"
    >
      <template v-slot:activator="{ props: activatorProps }">
          <v-btn prepend-icon="mdi-plus" v-bind="activatorProps" color="primary" :disabled="terminer">
            Ajouter
        </v-btn>
      </template>
      <v-card
        title="Ajouter un article"
      >
        
          <v-card-text>
            <v-row dense>
              <v-col  cols="12" md="4" sm="6"
              >
              <v-combobox
                      clearable
                      label="Marques"
                      :items="itemsmarques"
                      v-model="marque"
                      variant="outlined"
                      :rules="rules(marque,'Marque','')"
                      :style="[marque?{'color':'green'}:{'color':'red'}]"
                  ></v-combobox>
              </v-col>
              <v-col  cols="12" md="4" sm="6"
              >
              <v-combobox
                      clearable
                      label="Thèmes"
                      :items="itemsThemes"
                      v-model="theme"
                      variant="outlined"
                      :rules="rules(theme,'Thème','')"
                      :style="[theme?{'color':'green'}:{'color':'red'}]"
                  ></v-combobox>
              </v-col>

              <v-col  cols="12" md="4" sm="6"
              >
              <v-combobox
                      clearable
                      label="Composition"
                      :items="itemsComposition"
                      v-model="composition"
                      variant="outlined"
                      :rules="rules(composition,'Composition','')"
                      :style="[composition?{'color':'green'}:{'color':'red'}]"
                  ></v-combobox>
              </v-col>

              <v-col  cols="12" md="4" sm="6"
              >
                <v-text-field
                  label="Prix Public TTC"
                  v-model="prixPVC"

                  prefix="€"
                  :rules="rules(prixPVC,'Prix PVC','^[0-9]*$')"
                  :style="[prixPVC?{'color':'green'}:{'color':'red'}]"
                ></v-text-field>
              </v-col>

              <v-col  cols="12" md="4" sm="6"
              >
              <v-combobox
                      clearable
                      label="SousFamille"
                      :items="itemsSousFamille.filter(el=>el.split('')[0]=='F').sort()"
                      v-model="sousFamille"
                      variant="outlined"
                      :rules="rules(sousFamille,'SousFamille','')"
                      :style="[sousFamille?{'color':'green'}:{'color':'red'}]"
                  ></v-combobox>
              </v-col>

              <v-col cols="12" md="4" sm="6"
              >
              <v-combobox
                      clearable
                      label="Lib couleur"
                      :items="itemscouleur"
                      v-model="couleur"
                      variant="outlined"
                      :rules="rules(couleur,'Lib couleur','')"
                      :style="[couleur?{'color':'green'}:{'color':'red'}]"
                      
                  >
                </v-combobox>
              </v-col>

              <v-col cols="12" md="4" sm="6"
              >
              <v-text-field
                  label="Prix Achat"
                  v-model="prixAchat"
                  prefix="€"
                  :rules="rules(prixAchat,'Prix Achat','^[0-9]*[.,]?[0-9]*$')"
                  :style="[prixAchat?{'color':'green'}:{'color':'red'}]"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4" sm="6"
              >
              <v-text-field
                  label="QTE"
                  v-model="qteCommande"
                  :rules="rules(qteCommande,'QTE','^[0-9]*$')"
                  :style="[qteCommande?{'color':'green'}:{'color':'red'}]"
                  
              ></v-text-field>
              
              </v-col>
              <v-col  cols="12" md="4" sm="6"
              >
              <v-text-field
                  label="Poids"
                  v-model="poids"
                  prefix="kg"
                  :rules="rules2(poids,'Poids','^[0-9]*[.,]?[0-9]*$')"
              ></v-text-field>
              
              </v-col>
              <v-col  cols="12" md="4" sm="6"
              >
              <v-text-field
                  label="Dimensions"
                  v-model="dimensions" 
                  placeholder="L*H*P"
                  :rules="rules2(dimensions,'Dimensions','^[0-9]*[*]*[0-9]*[*]*[0-9]$')"
              ></v-text-field>
              
              </v-col>
              <v-col  cols="12"  md="4"  sm="6"
              >
              <v-text-field
                  label="Volume"
                  v-model="litrage"
                  prefix="L"
                  :rules="rules2(litrage,'Volume','^[0-9]*[.,]?[0-9]*$')"
              ></v-text-field>
              
              </v-col>
              <v-col  cols="12" md="4"  sm="6"
              >
              <v-text-field
                  label="Fournisseur"
                  v-model="store.state.codeFournisseur.code"
                  :rules="rules(store.state.codeFournisseur.code,'Fournisseur','^[0-9]{6}$')"
                  :disabled="store.state.codeFournisseur.updated"
              ></v-text-field>
              
              </v-col>
              <v-col  cols="11" md="4" sm="6"
              >
              <v-text-field
                  label="Remarque"
                  v-model="remarque"
              ></v-text-field>
              
              </v-col>
              <v-col  cols="12"  md="4"  sm="6"
              >
              
              </v-col>
              <v-col cols="12"  md="4"  sm="6"
              >
              <v-text-field
                  label="Nombre"
                  v-model="nbre"
                  required
                  :rules="rules(nbre,'Nombre','^[0-9]*$')"
                  :style="[nbre?{'color':'green'}:{'color':'red'}]"
              ></v-text-field>
              
              </v-col>
            </v-row>

            <small class="text-caption text-medium-emphasis"> <span style="color:red">*les colonnes rouges sont obligatoires</span></small>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              text="Fermer"
              variant="plain"
              @click="dialog = false"
              color="red"
            ></v-btn>

            <v-btn
              color="primary"
              text="Valider"
              variant="plain"
              :disabled="!store.state.codeFournisseur.code||prixPVC<=0||prixAchat<=0||!composition||!theme||!marque||!sousFamille||!couleur||nbre<0||!valid?true:false"
              @click="dialog = false;sendArticle()"
              type="submit" 
            ></v-btn>
          </v-card-actions>  
        </v-card>
        
      
    </v-dialog>

  </div>
  </form>
  
</template>
<script setup>
import { ref,computed, onMounted } from 'vue';
import store from './store';
import axios from 'axios'
const props=defineProps({
  terminer:Boolean
})
 let disabled=ref()
 let itemsmarques=['1-OTHER',	'10-BALI BALO',	'100-143',	'1000-M0851',	'1001-AMD',	'1002-NEMO',	'1003-satch',	'1004-ANGRY BIRDS',	'1005-ALL BLACKS',	'1006-MINNIE',	'1007-PRINCESS',	'1008-SPIDERMAN',	'1009-MICKEY',	'101-MANDARINA DUCK',	'1010-PEPE JEANS',	'1011-REPTILES HOUSE',	'1012-LOLLIPOPS',	'1013-BEAUMONT',	'1014-MODALU',	'1015-ALEXANDER MCQUEEN McQ',	'1016-ASHTAG',	'1017-NAPAPIJRI',	'1018-ZINE',	'1019-collection PRIVEE',	'102-145',	'1020-ANDREA MABIANI',	'1021-CABIN ZERO',	'1022-KAPORAL',	'1023-BESTINI',	'1024-MARC BY MARC JACOBS',	'1025-DAVID WILLIAM',	'1026-PETITE MENDIGOTE',	'1027-SELECTION DESCHILDER',	'1028-PAJAR',	'1029-KNIRPS',	'103-146',	'1030-MOSCHIKO',	'1031-TAMARIS',	'1032-BABYBOTTE',	'1033-MUSTANG',	'1034-GABOR',	'1035-SPIRAL',	'1036-MEPHISTO',	'1037-BULL BOXER',	'1038-KHRIO',	'1039-KOST',	'104-147',	'1040-GREENSTONE',	'1041-SHINE BLOSSOM',	'1042-PALLADIUM',	'1043-P-L-D-M',	'1044-JHAY',	'1045-NO BOX',	'1046-NALU',	'1047-HAVAIANAS',	'1048-UNISA',	'1049-PANTOFOLA DORO',	'105-148',	'1050-DKNY',	'1051-WHOOZ',	'1052-AMERICAN TOURISTER',	'1053-LES TROPEZIENNES',	'1054-NOEL',	'1055-BOPY',	'1056-LESPORTSAC',	'1057-FERRARI',	'1058-MACLAUREN',	'1059-THELMA FEWO',	'106-149',	'1060-NEVADA LOVE',	'1061-JAPAN RAGS',	'1062-PLANES',	'1063-VIOLETTA',	'1064-SKECHERS',	'1065-KENNEL/SCHMENGER',	'1066-STADE TOULOUSAIN',	'1067-BELLAMY',	'1068-JEUNE PREMIER',	'1069-THUNDERCATS',	'107-150',	'1070-HERSCHEL',	'1071-ASTER',	'1072-MELINE',	'1073-NEW BALANCE',	'1074-REBECCA MINKOFF',	'1075-MAISON MARTIN MARGIELA',	'1076-KARL LAGERFELD',	'1077-JASON WU',	'1078-BURBERRY',	'1079-JOTT',	'108-151',	'1080-FLO CLO',	'1081-ANTONYME',	'1082-DONDERS',	'1083-BUGATTI',	'1084-DEELUXE',	'1085-REINE DES NEIGES',	'1086-ESCANDELLE',	'1087-PATRIZIA PEPE',	'1088-MI PAC',	'1089-NO NAME',	'109-PIGANIOL',	'1090-FILA',	'1091-MILANO COLLEZIONE',	'1092-PIPERMARU',	'1093-MILA LOUISE',	'1094-INUOVO',	'1095-MARUTI',	'1096-MANAS',	'1097-MA.CRI',	'1098-PAULS BOUTIQUE',	'1099-BLEU DE CHAUFFE',	'11-BIASIA FRANCESCO',	'110-PAQUETAGE',	'1100-CANADA GOOSE',	'1101-FUCHS SCHMITT',	'1102-BASE LONDON',	'1103-ABRO',	'1104-ATTENTIF',	'1105-CHARLIOR',	'1106-CALVER',	'1107-PALLADIUM KID',	'1108-P-L-D-M KID',	'1109-MJUS',	'111-PAS UTILISER 154PPS',	'1110-DR MARTENS',	'1111-VANS',	'1112-SPM',	'1113-VICTORIA',	'1114-REQINS',	'1115-PIECES',	'1116-BUNKER',	'1117-DANIEL HECHTER',	'1118-LA MARTINA',	'1119-FRANCESCO MILANO',	'112-155',	'1120-COLYNN',	'1121-ERYNN',	'1122-SECRID',	'1123-FROZEN',	'1124-TEO JASMIN',	'1125-FEDERAT. FRANCE FOOTBALL',	'1126-LEON FLAM',	'1127-KARL MARC JOHN',	'1128-HAROLDS',	'1129-SOFIA',	'113-POURCHET',	'1130-LOVE MOSCHINO',	'1131-ZANIMOS',	'1132-MINIONS',	'1133-AQUA LEATHER',	'1134-ROADSIGN',	'1135-NEW BALANCE KID',	'1136-LONGBOARD',	'1137-PAT PATROUILLE',	'1138-SAM LE POMPIER',	'1139-REPETTO',	'114-157',	'1140-DICKIES',	'1141-AILEEN',	'1142-KATE SPADE',	'1143-PAUL ET JOE SISTER',	'1144-COACH',	'1145-KJORE PROJECT',	'1146-LEGEND',	'1147-GRAFFITY',	'1148-LEMON JELLY',	'1149-FPM',	'115-158',	'1150-STAR WARS',	'1151-LAUREN RALPH LAUREN',	'1152-GUESS SHOES',	'1153-I CLIP',	'1154-BULL BOXER KID',	'1155-CYCLEUR DE LUXE',	'1156-PATRICK',	'1157-LAMBORGHINI',	'1158-CHEVROLET',	'1159-GABS',	'116-159',	'1160-LILI PETROL',	'1161-JUSTO',	'1162-SAVE MY BAG',	'1163-VERA PELLE',	'1164-KART',	'1165-PUMA SHOES',	'1166-CONVERSE SHOES',	'1167-ROSE GARDEN',	'1168-PEPE JEANS SHOES',	'1169-VANESSA WU',	'117-160',	'1170-TANTREND',	'1171-PINKISS',	'1172-BLUE PEARL',	'1173-REPARATION',	'1174-ORICE',	'1175-ONE OF US',	'1176-COWO',	'1177-BIRKENstock',	'1178-VIDOU',	'1179-ST DUPONT',	'118-PAS UTILISER 161PPS',	'1180-REAL MADRID',	'1181-KWELL',	'1182-VENQUE',	'1183-AVENGERS',	'1184-ZOOTOPIA',	'1185-DORY',	'1186-CHICA VAMPIRO',	'1187-LECONS DE CHOSES',	'1188-POIDS PLUME',	'1189-EGGMAN',	'119-162',	'1190-KUTS',	'1191-FJALLRAVEN',	'1192-SOY LUNA',	'1193-TOUS',	'1194-JACK AND JONES',	'1195-GEOX',	'1196-MINIBEL',	'1197-KANNA',	'1198-VEJA',	'1199-HUGO BOSS',	'12-PAS UTILISER 017PPS',	'120-163',	'1200-BOMBERS ORIGINAL',	'1201-JAYLOUCY',	'1202-SK8',	'1203-BURKELY',	'1204-SELECTED',	'1205-EXISTENZ',	'1206-GIPSY',	'1207-CATCH ME',	'1208-POLO RALPH LAUREN',	'1209-CRAZY LOU',	'121-164',	'1210-UNICEF',	'1211-CHIARUGI',	'1212-ARMISTICE',	'1213-WYLSON',	'1214-FRODDO',	'1215-ONLY',	'1216-PAUL MARIUS',	'1217-MEEXUP',	'1218-D.A.T.E',	'1219-GANADORA',	'122-PICARD',	'1220-VIDORRETA',	'1221-NEUVILLE',	'1222-SOUVE BAG CO',	'1223-PLAKTON',	'1224-TROLLS',	'1225-THE PACK SOCIETY',	'1226-VAIANA',	'1227-YOKAI WATCH',	'1228-PAW PATROL',	'1229-AFFENZAHN',	'123-PACO RABANNE',	'1230-MARCIANO',	'1231-MIRACULOUS',	'1232-LAISSEZ LUCIE FAIRE',	'1233-LOVE LOVE',	'1234-GEORGES RECH',	'1235-PYRENEX',	'1236-C.M.P.55',	'1237-CANADIAN',	'1238-0-105',	'1239-GOLDEN HEAD',	'124-167',	'1240-LUNDI',	'1241-STARLING',	'1242-KDOPA',	'1243-HOLYSKIN',	'1244-VILANOVA',	'1245-UGG',	'1246-SWISS BAGS',	'1247-BRENDA ZARO',	'1248-BILLYBELT',	'1249-EMPORIO ARMANI',	'125-168',	'1250-JACADI',	'1251-SCHMOOVE',	'1252-RAINS',	'1253-XD DESIGN',	'1254-DEERCRAFT',	'1255-VERO MODA',	'1256-CONHPOL',	'1257-TONI PONS',	'1258-MICKEY AND MINNIE MOUSE',	'1259-KIDZROOM',	'126-169',	'1260-FILT',	'1261-THE WHITE BRAND',	'1262-KOBEN',	'1263-SANDQVIST',	'1264-PJMASKS',	'1265-POKEMON',	'1266-JP BY JEUNE PREMIER',	'1267-ANIMAL',	'1268-SMILEY',	'1269-EMOJI',	'127-RONCATO',	'1270-CARAMEL ET CIE',	'1271-GOLLA',	'1272-LES SKEWIES',	'1273-TORTUES NINJA',	'1274-DISNEY',	'1275-NBA',	'1276-SWEET PANTS',	'1277-LEGO',	'1278-BAKKER',	'1279-MUESLII',	'128-RODELLE',	'1280-BENFICA',	'1281-LA LICORNE MAGIQUE',	'1282-CHATTAWAK',	'1283-E-COW',	'1284-FOLIES',	'1285-VICTIM',	'1286-BRONX',	'1287-LEA TONI',	'1288-ELISA LANCI',	'1289-HAPPY SOCKS',	'129-CARRE ROYAL',	'1290-BRAND CONNECTION',	'1291-CABAIA',	'1292-TED BAKER',	'1293-ANEKKE',	'1294-CHANEL',	'1295-CLIMA',	'1296-SORUKA',	'1297-BONS BAISERS DE PANAME',	'1298-BUFFALO',	'1299-MAMZELLE',	'13-019',	'130-REDSKINS',	'1300-LE VOYAGE EN PANIER',	'1301-CARDENAL',	'1302-ELLESSE',	'1303-LES SPARTIATES PHOCEENNES',	'1304-LARMORIE',	'1305-ARTE FINO',	'1306-NASA',	'1307-BY BRICS',	'1308-DIGEL',	'1309-PEPPA PIG',	'131-176',	'1310-PYJAMASQUES',	'1311-THE LION KING',	'1312-STONES AND BONES',	'1313-MAGIC SWAN',	'1314-ALLEZ LES BLEUS',	'1315-EGGMANIA BY DDP',	'1316-PUSHEEN',	'1317-MY FAVORITE',	'1318-JACK PIERS',	'1319-LES DEGLINGOS',	'132-REPSTYLE',	'1320-VANESSA BRUNO',	'1321-POL FOX',	'1322-TEST LAURENT',	'1323-BIBA',	'1324-FAGUO',	'1325-SALTED',	'1326-ECOALF',	'1327-CARMELA',	'1328-SPRAYGROUND',	'1329-SEMERDJIAN',	'133-179',	'1330-AROGADO BY JUMP',	'1331-ARCHIPEL',	'1332-CRAIE',	'1333-BLACKSTONE',	'1334-SAC US',	'1335-DORKING',	'1336-THE JACKSONS',	'1337-BALENCIAGA',	'1338-BANDIT MANCHOT / ETRIER',	'1339-NATURAL WORLD',	'134-PAS UTILISER 181PPS',	'1340-ROLAND GARROS',	'1341-FLUCHOS',	'1342-MILKY KISS',	'1343-SKOOTER',	'1344-STREET',	'1345-SKY',	'1346-LOL',	'1347-GUNS',	'1348-UCON ACROBATICS',	'1349-AS98',	'135-183',	'1350-LAURA VITA',	'1351-DAVID JONES',	'1352-EXZ',	'1353-AUGRE F',	'1354-KAPTEN AND SON',	'1355-HOFF',	'1356-GIOSEPPO',	'1357-VALENTINO BAGS',	'1358-LA MAISON DE LESPADRILLE',	'1359-SMARTY',	'136-184',	'1360-HAPPYNESS',	'1361-BLACKLINES',	'1362-PREGUNTA',	'1363-PINKO',	'1364-MATT ET NAT',	'1365-REISENTHEL',	'1366-MERO MERO',	'1367-WOUF',	'1368-ARSAYO',	'1369-DIADORA',	'137-186',	'1370-FITZ AND HUXLEY',	'1371-AQTE2',	'1372-PATROUILLE DE FRANCE',	'1373-ARMANI EXCHANGE',	'1374-SUPERGA',	'1375-NATURE IS FUTURE',	'1376-PARKING',	'1377-ALLROUNDER',	'1378-ATOLL PALME',	'1379-TRIXIE',	'138-187',	'1380-AQTE2',	'1381-HELLY HANSEN',	'1382-LE FORMIER',	'1383-RUCKFIELD',	'1384-LA COQUE FRANCAISE',	'1385-HINDBAG',	'1386-BAGSMART',	'1387-CHABRAND',	'1388-TRAVELITE',	'1389-STEVE MADDEN',	'139-188',	'1390-SAPHIR',	'1391-MYMA',	'1392-FLOTTE',	'1393-COLORS OF CALIFORNIA',	'1394-ELUE PAR NOUS',	'1395-METAMORFOSE',	'1396-EOLIGEROS',	'1397-LUNE ET LAUTRE',	'1398-WE DO',	'1399-CACATOES',	'14-020',	'140-CHEVIGNON',	'1400-GERARD PASQUIER',	'1401-ALMA EN PENA',	'1402-ALPE',	'1403-FEDERAT. FRANCE RUGBY',	'1404-PRET',	'1405-POIVRE BLANC',	'1406-HELLO HOSSY',	'1407-AIGLE',	'1408-ROCK AND ROSE',	'1409-ARROBA',	'141-192',	'1410-PS POELMAN',	'1411-BINDI ATELIER',	'1412-PS POELMAN',	'1413-CLUSE',	'1414-OSKOL',	'1415-NEW ERA',	'1416-ILSE JACOBSEN',	'1417-TRIPLUS',	'1418-GIO+',	'1419-XAPATAN',	'142-193',	'1420-MARIE MARTENS',	'1421-HEY DUDE',	'1422-CLARKS',	'1423-VIRGINIE DARLING',	'1424-HAPPY50',	'1425-MAC ALYSTER',	'1426-SARA MODA',	'1427-LILO & STITCH',	'1428-FORTNITE',	'1429-VERBENAS',	'143-194',	'1430-LOLA CASADEMUNT',	'1431-NO BRAND',	'1432-GORILLA',	'1433-BY BYBLOS',	'1434-ALOHAS',	'1435-N°6',	'1436-LAURENT DAVID',	'1437-JEEP',	'1438-FIFILLE CLUB',	'1439-MAVERICK',	'144-TRADITION RENOUEE',	'1440-LOUIS VUITTON',	'1441-PRADA',	'1442-TODS',	'1443-BLUNDSTONE',	'1444-KLEMAN',	'1445-KOST',	'1446-MOON BOOT',	'1447-XTI',	'1448-SOLEX',	'1449-THE ICONA',	'145-197',	'1450-TT. BAGATT',	'1451-MINECRAFT',	'1452-VIAMAILBAG',	'1453-FROZEN 2',	'1454-RIVEDROITE',	'146-198',	'147-TANNS',	'148-200',	'149-202',	'15-021',	'150-PAS UTILISER 203PPC',	'1501-TANTA',	'1502-SUN68',	'1503-REMONTE',	'1504-ANOTHER STEP',	'1505-COOLWAY',	'1506-CROCS',	'1507-ALIWELL',	'1508-MAISON TOUFET',	'1509-METISSE',	'151-204',	'1510-MoEa',	'1511-COCO ABRICOT',	'1512-GAIMO',	'1513-NAN-KU COUTURE',	'1514-NUYOU',	'152-205',	'153-PAS UTILISER 206PPS',	'154-207',	'155-209',	'156-210',	'158-214',	'159-216',	'16-022',	'160-220',	'161-MINIPRIX',	'162-BORDONESE',	'163-WALTER KIEL',	'164-DESCHILDER',	'165-228',	'166-230',	'167-234',	'168-DXN ROSSI',	'169-BRUNO ROSSI',	'17-023',	'170-237',	'171-238',	'172-239',	'173-PORSCHE DESIGN',	'174-243',	'175-BRICS',	'176-PAS UTILISER 250PPS',	'177-251',	'178-252',	'179-256',	'18-024',	'180-257',	'181-HALLIBURTON',	'182-259',	'183-260',	'184-YVES SAINT LAURENT',	'185-265',	'186-281',	'187-FRANCINEL',	'188-LANCASTER',	'189-286',	'19-025',	'190-289',	'191-290',	'192-LONGCHAMP',	'193-LAVILLA DIDIER',	'194-293',	'195-UPLA',	'196-295',	'197-310',	'198-312',	'199-314',	'2-002',	'20-PAS UTILISER 026PPC',	'200-COCCINELLE',	'201-PAS UTILISER 317PPS',	'202-318',	'203-320',	'204-321',	'205-322',	'206-CHRISTIAN DIOR',	'207-325',	'208-CELINE',	'209-327',	'21-027',	'210-331',	'211-334',	'212-335',	'213-COURREGES BY EASTPAK',	'214-339',	'215-340',	'216-341',	'217-CALVIN KLEIN JEANS',	'218-343',	'219-COLLONIL',	'22-029',	'220-345',	'221-ALAIN MIKLI',	'222-PAS UTILISER 348PPC',	'223-PAS UTILISER 349PPS',	'224-ARTHUR & ASTON',	'225-PAS UTILISER 351PPS',	'226-CARUCCI',	'227-354',	'228-CHRISTIAN LACROIX',	'229-357',	'23-030',	'230-358',	'231-PAS UTILISER 360PPS',	'232-403',	'233-404',	'234-408',	'235-DELSEY',	'236-500',	'237-501',	'238-502',	'239-ESCAPADE',	'24-031',
    '240-504',	'241-505',	'242-506',	'243-507',	'244-508',	'245-509',	'246-PAS UTILISER 510PPS',	'247-PAS UTILISER 511PPS',	'248-600',	'249-601',	'25-032',	'250-604',	'251-606',	'252-607',	'253-608',	'254-609',	'255-682',	'256-691',	'257-693',	'258-694',	'259-GIL HOLSTERS',	'26-033',	'260-696',	'261-697',	'262-GIORGIO',	'263-699',	'264-700',	'265-701',	'266-740',	'267-741',	'268-791',	'269-HEXAGONA',	'27-035',	'270-797',	'271-AGNELLE',	'272-801',	'273-NANNINI',	'274-803',	'275-804',	'276-807',	'277-824',	'278-901',	'279-902',	'28-036',	'280-903',	'281-905',	'282-906',	'283-907',	'284-908',	'285-909',	'286-SEQUOIA',	'287-911',	'288-912',	'289-913',	'29-039',	'290-914',	'291-915',	'292-919',	'293-920',	'294-922',	'295-SEGURA',	'296-SAMSONITE',	'297-925',	'298-SYLVAIN LEFEBVRE',	'299-929',	'3-003',	'30-040',	'300-930',	'301-SOCO',	'302-SONIA RYKIEL',	'303-935',	'304-936',	'305-NINA RICCI',	'306-941',	'307-951',	'308-952',	'309-953',	'31-041',	'310-955',	'311-956',	'312-957',	'313-958',	'314-959',	'315-TED LAPIDUS',	'316-THE BRIDGE',	'317-974',	'318-TEXIER',	'319-976',	'32-042',	'320-977',	'321-978',	'322-980',	'323-JUMP',	'324-JUST CAMPAGNE',	'325-993',	'326-994',	'327-UNGARO',	'328-998',	'329-999',	'33-045',	'330-262',	'331-QUIKSILVER',	'332-PININFARINA',	'333-JANSPORT',	'334-046',	'335-860',	'336-DDP',	'337-MATTEL',	'338-254',	'339-PAS UTILISER 355PPS',	'34-049',	'340-215',	'341-323',	'342-813',	'343-816',	'344-232',	'345-328',	'346-MONTBLANC',	'347-810',	'348-271',	'349-CHLOE',	'35-PAS UTILISER 050PPS',	'350-103',	'351-TOSCA BLU',	'352-ELLE',	'353-229',	'354-011',	'355-921',	'356-825',	'357-006',	'358-233',	'359-015',	'36-051',	'360-GLOVE STORY',	'361-CHARLES JOURDAN',	'362-EASTPAK',	'363-830',	'364-937',	'365-OXYDE',	'366-401',	'367-245',	'368-065',	'369-253',	'37-055',	'370-246',	'371-201',	'372-218',	'373-603',	'374-102',	'375-137',	'376-231',	'377-247',	'378-171',	'379-085',	'38-FOURES',	'380-173',	'381-099',	'382-942',	'383-PARABOOT',	'384-248',	'385-217',	'386-422',	'387-PAS UTILISER 274PPS',	'388-979',	'389-177',	'39-059',	'390-CP',	'391-386',	'392-387',	'393-388',	'394-389',	'395-390',	'396-MALIPARMI',	'397-LANCEL',	'398-FURLA',	'399-513',	'4-004',	'40-PAS UTILISER 061PPS',	'400-514',	'401-391',	'402-DEMI-SEL',	'403-393',	'404-PAS UTILISER 394PPC',	'405-TUMI',	'406-423',	'407-249',	'408-981',	'409-424',	'41-062',	'410-PAS UTILISER 515WOOMEN',	'411-516',	'412-982',	'413-TIMBERLAND',	'414-570',	'415-067',	'416-425',	'417-112',	'418-361',	'419-362',	'42-063',	'420-363',	'421-364',	'422-TRIANGLE',	'423-PAS UTILISER 397ETRIER',	'424-SNOWBALL',	'425-427',	'426-189',	'427-517',	'428-219',	'429-997',	'43-064',	'430-185',	'431-428',	'432-YVES RENARD',	'433-365',	'434-610',	'435-PAS UTILISER 611PPS',	'436-967',	'437-612',	'438-614',	'439-399',	'44-JP GAULTIER',	'440-366',	'441-615',	'442-831',	'443-367',	'444-429',	'445-918',	'446-518',	'447-368',	'448-BERGE',	'449-PAULE KA',	'45-068',	'450-943',	'451-944',	'452-616',	'453-702',	'454-752',	'455-430',	'456-753',	'457-754',	'458-278',	'459-571',	'46-PAS UTILISER 069PPS',	'460-369',	'461-519',	'462-617',	'463-618',	'464-619',	'465-793',	'466-301',	'467-755',	'468-431',	'469-432',	'47-GERARD HENON',	'470-620',	'471-621',	'472-622',	'473-166',	'474-060',	'475-550',	'476-PAS UTILISER 623PPC',	'477-624',	'478-433',	'479-PAS UTILISER 520PPC',	'48-074',	'480-521',	'481-522',	'482-703',	'483-704',	'484-705',	'485-989',	'486-PIQUADRO',	'487-960',	'488-760',	'489-761',	'49-075',	'490-762',	'491-763',	'492-764',	'493-765',	'494-766',	'495-767',	'496-768',	'497-769',	'498-770',	'499-771',	'5-007',	'50-PAS UTILISER 076PPS',	'500-772',	'501-PAS UTILISER 773PPC',	'502-774',	'503-775',	'504-410',	'505-706',	'506-777',	'507-776',	'508-814',	'509-817',	'51-PAS UTILISER 078HEDGREN',	'510-572',	'511-LEDERER',	'512-778',	'513-779',	'514-191',	'515-573',	'516-PAS UTILISER 780PPC',	'517-781',	'518-PAS UTILISER 782PPC',	'519-PAS UTILISER 783PPC',	'52-HERVE CHAPELIER',	'520-784',	'521-785',	'522-GOLA',	'523-370',	'524-296',	'525-904',	'526-832',	'527-833',	'528-834',	'529-835',	'53-080',	'530-836',	'531-837',	'532-838',	'533-839',	'534-840',	'535-841',	'536-842',	'537-843',	'538-844',	'539-845',	'54-081',	'540-846',	'541-LONSDALE',	'542-MERC',	'543-847',	'544-848',	'545-849',	'546-850',	'547-851',	'548-852',	'549-853',	'55-ISOTONER',	'550-854',	'551-LACOSTE',	'552-855',	'553-PAS UTILISER 856PPC',	'554-857',	'555-PAS UTILISER 858PPC',	'556-859',	'557-916',	'558-213',	'559-371',	'56-088',	'560-861',	'561-PAS UTILISER 862PPC',	'562-PAS UTILISER 863PPC',	'563-PAS UTILISER 864PPC',	'564-PAS UTILISER 865PPC',	'565-PAS UTILISER 866ETRIER',	'566-476',	'567-477',	'568-945',	'569-478',	'57-PAS UTILISER 089PPS',	'570-787',	'571-788',	'572-523',	'573-867',	'574-868',	'575-372',	'576-336',	'577-BENSIMON',	'578-IL BISONTE',	'579-PAS UTILISER 411PPS',	'58-091',	'580-900',	'581-PAS UTILISER 373PPS',	'582-869',	'583-479',	'584-480',	'585-082',	'586-300',	'587-481',	'588-482',	'589-805',	'59-092',	'590-940',	'591-917',	'592-707',	'593-PAS UTILISER 870ETRIER',	'594-3',	'595-NATHAN BAUME',	'596-412',	'597-413',	'598-927 SAMSONITE',	'599-434',	'6-008',	'60-093',	'600-297',	'601-PAS UTILISER 374PPS',	'602-HEDGREN',	'603-NOBODY',	'604-435',	'605-436',	'606-053',	'607-414',	'608-884',	'609-871',	'61-PAS UTILISER 094UPLA',	'610-872',	'611-375',	'612-483',	'613-437',	'614-438',	'615-RIMOWA',	'616-439',	'617-PAS UTILISER 790PPS',	'618-873',	'619-288',	'62-095',	'620-TONY ENZO',	'621-347',	'622-PAS UTILISER 415PPS',	'623-070',	'624-PAS UTILISER 874ETRIER',	'625-8',	'626-083',	'627-086',	'628-087',	'629-416',	'63-096',	'630-LUPO',	'631-BRACCIALINI',	'632-196',	'633-CRINKLES',	'634-TIBANA',	'635-PAS UTILISER 794PPC',	'636-795',	'637-212',	'638-263',	'639-267',	'64-097',	'640-268',	'641-269',	'642-270',	'643-272',	'644-071',	'645-PAS UTILISER 279LANCASTER',	'646-378',	'647-TRAVEL',	'648-PAS UTILISER 988PPC',	'649-987',	'65-098',	'650-986',	'651-JEROME DREYFUSS',	'652-PAS UTILISER 283PPS',	'653-MANHATTAN PORTAGE',	'654-PERLETTI',	'655-PAS UTILISER 333NATHAN',	'656-PAS UTILISER 876PPC',	'657-PAS UTILISER 298PPS',	'658-299',	'659-PAS UTILISER 028PPS',	'66-101',	'660-947',	'661-303',	'662-889',	'663-PAS UTILISER 984PPC',	'664-PAS UTILISER 985ETRIER',	'665-PAS UTILISER 304PPS',	'666-305',	'667-PUMA',	'668-309',	'669-MINORITY',	'67-104',	'670-FAC',	'671-311',	'672-PAS UTILISER 970PPC',	'673-313',	'674-315',	'675-319',	'676-329',	'677-330',	'678-332',	'679-PAS UTILISER 337ETRIER',	'68-105',	'680-379',	'681-VICTORINOX',	'682-948',	'683-381',	'684-OGON',	'685-383',	'686-PAS UTILISER 879PPC',	'687-PAS UTILISER 878PPS',	'688-RAISON DETRE',	'689-PAS UTILISER 384TRAVEL',	'69-106',	'690-ALCHIMIA',	'691-708',	'692-385',	'693-625',	'694-GUESS',	'695-PAS UTILISER 398PPS',	'696-402',	'697-PAS UTILISER 417MEXX',	'698-418',	'699-419',	'7-009',	'70-KENZO',	'700-420',	'701-441',	'702-PAS UTILISER 828PPC',	'703-PAS UTILISER 829PPC',	'704-PAS UTILISER 442PPS',	'705-PAS UTILISER 443PPS',	'706-BASILIC PEPPER',	'707-PAS UTILISER 827PPC',	'708-445 VOIR AURELIE',	'709-CACTUS',	'71-108',	'710-PAS UTILISER 897BASILIC',	'711-898',	'712-LORENZO LEBON',	'713-880',	'714-PAS UTILISER 709ETRIER',	'715-DAYTONA',	'716-PAS UTILISER 969PPC',	'718-450',	'719-451',	'72-109',	'720-452',	'721-DIESEL',	'722-421',	'723-826',	'724-453',	'725-OILILY',	'726-968',	'727-966',	'728-455',	'729-964',	'73-KIPLING',	'730-965',	'731-ETRIER',	'732-456',	'733-Petit Prix Cuir',	'734-ROXY',	'735-NIKE',	'736-TORROW',	'737-CAMELEON',	'738-PUCCA',	'739-DORA',	'74-LE TANNEUR',	'740-SPIDER MAN',	'741-457',	'742-WOOMEN',	'743-458',	'744-881',	'745-460',	'746-461',	'747-462',	'748-463',	'749-464',	'75-113',	'750-MEXX',	'751-963',	'752-466',	'753-465',	'754-962',	'755-ESPRIT',	'756-ENTRA',	'757-G.G.LUCY',	'758-CONVERSE',	'759-CHIPIE',	'76-114',	'760-HELLO KITTY',	'761-VON DUTCH',	'762-ED HARDY',	'763-AIRNESS',	'764-CHARLOTTE AUX FRAISES',	'765-OAKWOOD',	'766-FANLOUIS',	'767-GIOVANNI',	'768-ARTURO',	'769-SKINERS',	'77-115',	'770-POLO',	'771-BIASIA',	'772-JOST',	'773-ELITE',	'774-PAUL ET JOE',	'775-KATANA',	'776-VAHO',	'777-INFLUENCE',	'778-VALENTINO',	'779-ELYSTON',	'78-OXONE',	'780-PIERRE CARDIN',	'781-HAPPY RAIN',	'782-AH',	'783-US',	'784-HENRY BEGUELIN',	'785-SERGE PARIENTE',	'786-LUMI',	'787-DOLCE GABBANA',	'788-THIERRY MUGLER',	'789-AYRENS',	'79-117',	'790-CHANTAL THOMASS',	'791-BENETTON',	'792-NICA',	'793-SILVER',	'794-MY WALIT',	'795-MADISSON',	'796-DAVID ET SCOTTI',	'797-818',	'798-JUST CAVALLI',	'799-GIANFRANCO FERRE',	'8-KESSLORDdddd',	'80-118',	'800-LULU CASTAGNETTE',	'801-PUNTOTRES',	'802-CARS',	'803-FAIRIES',	'804-EXPANSIVE',	'805-IMPERIAL',	'806-JACK SPARROW',	'807-DIEGO',	'808-DESIGUAL',	'809-DAKINE',	'81-119',	'810-DC',	'811-GAMBINI',	'812-CNC',	'813-KAPORALS',	'814-GALLIANO',	'815-JACKS FACE',	'816-STRAWBERRY',	'817-BATMAN',	'818-MISTER JACK',	'819-LULUBENDI',	'82-120',	'820-COABAN',	'821-BECATO',	'822-APRILE',	'823-SOFTY',	'824-CAMPOMAGGI',	'825-JEKEL',	'826-LAURIDA',	'827-HLH',	'828-LINA',	'829-LAUREMYX',	'83-121',	'830-JAUNE ROUGE',	'831-ALEXO',	'832-SUPERMAN',	'833-EUROLINE',	'834-F',	'835-GIADA',	'836-DAVIDTS',	'837-JAMIE PAGE',	'838-GIANNI CHIARINI',	'839-GIUDIT',	'84-MOSCHINO',	'840-SPIRIT',	'841-BARBARA RIHL',	'842-CATHERINE PARRA',	'843-PARAVIDINO',	'844-GERARD DAREL',	'845-DIDDL',	'846-LUANA',	'847-ALEANTO',	'848-SERGE BLANCO',	'849-BAYSIDE',	'85-123',	'850-KUCH',	'851-JUICY COUTURE',	'852-PRETTY KITTY',	'853-TRANSFORMERS',	'854-KAI LAN',	'855-GORMITI',	'856-FIORELLI',	'857-DI GREGORIO',	'858-SORELLE DITALIA',	'859-KOTHAI',	'86-124',	'860-R ET Y AUGOUSTI',	'861-LITTLE PETSHOP',	'862-LEATHERFIELD',	'863-MAC DOUGLAS',	'864-PAUL FRANCK',	'865-OMEGA',	'866-GHIBLI',	'867-EGG INDUSTRIES BY DDP',	'868-BAKUGAN',	'869-SERGIO TACCHINI',	'87-125',	'870-KATHY VAN ZEELAND',	'871-CAPONI',	'872-SMASH',	'873-MENBUR',	'874-ROBERTO MENGONI',	'875-LITTLE MARCEL',	'876-SISLEY',	'877-FOURNITURES',	'878-LE COQ SPORTIF',	'879-GABRIEL ANGELI',	'88-126',	'880-B COOL',	'881-KICKERS',	'882-GUY DE JEAN',	'883-VICTORIA COUTURE',	'884-TOY STORY',	'885-LAPINS CRETINS',	'886-OUI OUI',	'887-NSEW',	'888-CNC FEMME',	'889-TILA MARCH',	'89-PAS UTILISER 127PPS',	'890-FRAIS DE PORT',	'891-LE TEMPS DES CERISES',	'892-JAMIN PUECH',	'893-MARC JACOBS',	'894-COCKTAIL',	'895-GIVENCHY',	'896-PANTONE',	'897-AVIREX',	'898-PEAU DANE',	'899-INTUITION',	'9-YUCATAN',	'90-128',	'900-VITA',	'901-JEAN GUISE',	'902-ANGELO',	'903-CUIR ET PEAUX',	'904-AVIATRIX',	'905-EPIDERME',	'906-EPIDERM',	'907-RUITERTASSEN',	'908-TRU VIRTU',	'909-NAT MAD',	'91-129',	'910-BENCH',	'911-UNICA',	'912-ANNA KASZER',	'913-ALEXIS MABILLE',	'914-FLORIAN DENICOURT',	'915-11 SEVIGNE',	'916-Abaco',	'917-CLAUDIA',	'918-COWBOYSBAG',	'919-FRANDI',	'92-130',	'920-SCALE',	'921-AIRTEX',	'922-LYS',	'923-BARBIE',	'924-HANNAH MONTANA',	'925-LEONHARD HEYDEN',	'926-JOSTE',	'927-HEMISPHERE SUD',	'928-LIU JO',	'929-SCHOTT',	'93-131',	'930-TAGGER',	'931-ARMANI JEANS',	'932-FRED PERRY',	'933-LA POMME DE LOVELEY',	'934-SUITSUIT',	'935-VENTIUNO',	'936-MORGAN',	'937-MICHAEL KORS',	'938-FUCHSIA',	'939-DUOLYNX',	'94-132',	'940-Petit Prix Vêtement',	'941-LEVIS',	'942-EDEN PARK',	'943-SAXOLINE',	'944-MLB/NEW-YORK YANKEES',	'945-ARMA',	'946-EDISAC',	'947-LIPAULT',	'948-QUESTION2 BY ARTHUR ASTON',	'949-VALERY DAMNON',	'95-ONEILL',	'950-SABRINA',	'951-DOT DROPS',	'952-DEELUXE74',	'953-VIMODA',	'954-LIEBESKIND',	'955-LAIGLON',	'956-LAURAJO',	'957-MOHSIN ALI',	'958-FABRIZIO',	'959-MOLTO',	'96-PAS UTILISER 138PPS',	'960-POWER RANGERS',	'961-CHUGGINGTON',	'962-MONSTER HIGH',	'963-IKKS',	'964-ADIDAS',	'965-OLYMPIQUE DE MARSEILLE',	'966-PARIS ST GERMAIN',	'967-FC BARCELONE',	'968-LOSC LILLE',	'969-MILANO',	'97-139',	'970-IRON MAN',	'971-LANVIN',	'972-FOSSIL',	'973-MELLOW YELLOW',	'974-GARFIELD',	'975-MOSHIN ALI',	'976-GAUDI',	'977-SID',	'978-LES PTITES BOMBES',	'979-SEE BY CHLOE',	'98-140',	'980-GREAT BY SANDIE',	'981-CERRUTI1881',	'982-NAT ET NIN',	'983-PIERRE BALMAIN',	'984-VERSACE JEANS',	'985-AZZARO',	'986-OWN STUFF',	'987-GALLANTRY',	'988-SONIA BY SONIA RYKIEL',	'989-Y NOT',	'99-MONTANA',	'990-CHYSTON 76',	'991-TOMMY HILFIGER',	'992-BEST MOUNTAIN',	'993-RIP CURL',	'994-LOXWOOD',	'995-PETROL',	'996-MYSUELLY',	'997-SUPERDRY',	'998-ERGOBAG',	'999-SACCOO',	'ALL01-ALTER EGO',	'ALL02-CASUAL',	'ALL03-INSOUCIANTE',	'ALL04-CLEMENCE',	'ALL05-RESONANCE',	'ALL06-MILAN',	'ALL07-A4',	'ALL08-GALA',	'CF01-COQUE',	'CF02-CHAINE']
 let itemsThemes=ref(['FRP-Fripe','PTC-Particulier','LUX-Luxe'])
 let itemsComposition=ref(['03-Cuir','06-Synthétique','44-Textile'])
 let itemsSousFamille=ref(['F1A-sac bandoulière',	'F1B-sac porté épaule',	'F1C-sac porté main',	'F1D-sac banane',	'F1E-sac à dos',	'F1F-sac de cérémomie',	'F1G-sac de soirée',	'F2A-porte-monnaie',	'F2B-portefeuille',	'F2C-porte-chéquier',	'F2D-tout-en-un',	'F2E-porte-clefs',	'F2F-porte-cartes',	'F2G-porte-papiers',	'F2H-étui lunettes',	'F2I-étui cigarettes',	'F2K-étui téléphone',	'F2L-trousse',	'F2M-agenda',	'F2N-étui passeport',	'F3A-gants',	'F3B-parapluie',	'F3C-ceinture',	'F3D-foulard',	'F3E-écharpe',	'F3F-chapeau',	'F3G-porte sac',	'F3H-organiseur de sac',	'F3I-coffret bijoux',	'F3J-coffret cadeau',	'F3K-sac provision à roulettes',	'F3L-sac provision',	'F3M-bijoux',	'F3N-bijoux de sac',	'F3O-bandoulière de sac',	'F3P-bonnet',	'F3Q-étole',	'F3R-masque lavable',	'F3S-Coque téléphone',	'F3T-Casquette',	'F3U-Chaine coque téléphone',	'F3V-Bandoulière coque téléphone',	'F3W-Patch',	'F3X-Adaptateur de telephone'])
 let itemscouleur=store.state.itemColors
 let nbre=ref()
 let couleur=ref()
 let sousFamille=ref()
 let marque=ref()
 let theme=ref()
 let composition=ref()
 let prixPVC=ref()
 let prixAchat=ref()
 let remarque=ref()
 let codeFournisseur=computed(()=>{return store.state.codeFournisseur.code})
 let litrage=ref()
 let dimensions=ref()
 let poids=ref()
 let qteCommande=ref(1)
 let cab=ref()
//  //console.log(composition.value);
 
  function gererateEAN13(){
    // console.log('test',store.state.cab);
    let ean=Number(store.state.cab)+10
    let ean13=ean.toString().substring(0,12)
    let c=Number(ean13[0])+Number(ean13[2])+Number(ean13[4])+Number(ean13[6])+Number(ean13[8])+Number(ean13[10])
    let b= 3*(Number(ean13[1])+Number(ean13[3])+Number(ean13[5])+Number(ean13[7])+Number(ean13[9])+Number(ean13[11]))
    let cle=(10-(b+c)%10)%10
    return ean13+cle.toString()
  }

 let article=computed(()=> {
    return {
      pole:'SecondLife',
      refFourn:  `${prixPVC.value}-${composition.value?composition.value.split('-')[1].substring(0, 1):''}-${sousFamille.value?sousFamille.value.split('-')[0].substring(0,2):''}`,
      nomProduit: `${prixPVC.value}-${composition.value?composition.value.split('-')[1].substring(0, 1):''}-${sousFamille.value?sousFamille.value.split('-')[0].substring(0,2):''}`,
      marque:  marque.value,
      theme:  theme.value,
      composition:  composition.value,
      prixPublicTTC:  prixPVC.value,
      sousFamille:  sousFamille.value,
      libCouleur:  couleur.value,
      prixAchatHT:  prixAchat.value,
      qteCommande:  qteCommande.value,
      poidnet:  poids.value,
      dimensions:  dimensions.value,
      litrage:  litrage.value,
      codeFournisseur:  store.state.codeFournisseur.code,
      remarque:  remarque.value,
      totalBrut:  qteCommande.value&&prixAchat.value?qteCommande.value*prixAchat.value:0,
      coefBrut:  prixAchat.value&&prixPVC.value?Number(prixPVC.value/prixAchat.value).toFixed(2):0,
      totalPVpublic:  qteCommande.value&&prixPVC.value?qteCommande.value*prixPVC.value:0,
      nbre: nbre.value
      
    }
 })

 let valid=ref(true)
  let rules=(value,libelle,reg)=>{
    let regex = new RegExp(reg)
    // console.log(regex);
    
    if (value){
      if(value.toString().match(regex)){
        valid.value=true
        return [true]
      } else{
        valid.value=false
        return [`Le ${libelle} n'est pas en bon format`]
      }
    }
    else{
      valid.value=false
      return [`Vous devez renseigner le ${libelle}`]
    }
      
  }
  let rules2=(value,libelle,reg)=>{
    let regex = new RegExp(reg)
    if (value){
      if(value.toString().match(regex)){
        valid.value=true
        return [true]
      } else{
        valid.value=false
        return [`Le ${libelle} n'est pas en bon format`]
      }
    }
  }
        
          
 async function addArticles(nbre){
  
  await getID()
  await getCAB()

  for(let i=0 ;i<nbre;i++){
    store.commit('addRowArticle',{...article.value,id:'FRI-'+(store.state.countId++).toString().padStart(6,"0")+couleur.value.split('-')[0],
    cab:gererateEAN13()
    })
    // console.log(store.state.articlesFripe);
    // console.log('gen',gererateEAN13());
    
    store.commit('updateglobalID',store.state.countId++)
    store.commit('updateCAB',gererateEAN13())
    // console.log('updateCAB',store.state.cab);
    // console.log('updateglobalID',store.state.countId);
    
    
  }
  sendGlobalID()
  sendCAB()
  // nbre=''
  // couleur=''
  // sousFamille=''
  // marque=''
  // theme=''
  // composition=''
  // prixPVC=''
  // prixAchat=''
  // remarque=''
  // codeFournisseur=''
  // litrage=''
  // dimensions=''
  // poids=''
  // qteCommande='1'
  // cab=''
 }
 function getID(){  
    let url=    `https://my.edisac.com/api/getID`
    // console.log(url)
    let config = {
    method: 'get',
    url: url
    };
    return   axios.request(config)
    .then((response) => {
        cab.value=response.data
        store.commit('updateglobalID',response.data)
    })
    .catch((error) => {
    //console.log(error);
    });

  }
  const sendGlobalID=()=>{
    
    let data = {countId:store.state.countId}
    
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/getID',
    headers: { 
        'Content-Type': 'application/json'
    },
    data : data
    }
    return axios.request(config)
    .then((response) => { 
        // console.log(response);
        
    })
    .catch((error) => {
    //console.log(error);
    });
  }
  const sendArticle=()=>{
    // let data = {article:article.value}
    // console.log(data);
    // console.log(codeFournisseur);
    if(!store.state.codeFournisseur.updated){
      store.commit('updateCodeFournisseur',store.state.codeFournisseur.code)
    }
    let data ={article:{
      pole:'SecondLife',
      refFourn:  `${prixPVC.value}-${composition.value?composition.value.split('-')[1].substring(0, 1):''}-${sousFamille.value?sousFamille.value.split('-')[0].substring(0,2):''}`,
      nomProduit: `${prixPVC.value}-${composition.value?composition.value.split('-')[1].substring(0, 1):''}-${sousFamille.value?sousFamille.value.split('-')[0].substring(0,2):''}`,
      marque:  marque.value,
      theme:  theme.value,
      composition:  composition.value,
      prixPublicTTC:  prixPVC.value,
      sousFamille:  sousFamille.value,
      libCouleur:  couleur.value,
      prixAchatHT:  prixAchat.value,
      qteCommande:  qteCommande.value,
      poidnet:  poids.value,
      dimensions:  dimensions.value,
      litrage:  litrage.value,
      codeFournisseur:  store.state.codeFournisseur.code,
      remarque:  remarque.value,
      totalBrut:  qteCommande.value&&prixAchat.value?qteCommande.value*prixAchat.value:0,
      coefBrut:  prixAchat.value&&prixPVC.value?Number(prixPVC.value/prixAchat.value).toFixed(2):0,
      totalPVpublic:  qteCommande.value&&prixPVC.value?qteCommande.value*prixPVC.value:0,
      nbre: nbre.value 
    }}
    // console.log(data);
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/getArticle',
    headers: { 
        'Content-Type': 'application/json'
    },
    data : data
    }
    return axios.request(config)
    .then((response) => { 
        // console.log(response);
        for(let i=0;i<response.data.length;i++){
          store.commit('addRowArticle',response.data[i])
        }
        nbre=ref()
        couleur=ref()
        sousFamille=ref()
        marque=ref()
        theme=ref()
        composition=ref()
        prixPVC=ref()
        prixAchat=ref()
        remarque=ref()
        codeFournisseur=ref()
        litrage=ref()
        dimensions=ref()
        poids=ref()
        qteCommande=ref(1)
    })
    .catch((error) => {
    //console.log(error);
    });
  }

  function getCAB(){  
    let url=    `https://my.edisac.com/api/cab`
    // console.log(url)
    let config = {
    method: 'get',
    url: url
    };
    return   axios.request(config)
    .then((response) => {
        store.commit('updateCAB',response.data)
    })
    .catch((error) => {
    //console.log(error);
    });
  }
  const sendCAB=()=>{
    
    let data = {cab:store.state.cab}
    // console.log('send',data);
    
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/cab',
    headers: { 
        'Content-Type': 'application/json'
    },
    data : data
    }
    return axios.request(config)
    .then((response) => { 
        //console.log(response);
        
    })
    .catch((error) => {
    //console.log(error);
    });
  }

  



  const dialog=ref(false)
  const ordered=(referenced) =>{
    return referenced.sort().reduce(
        (a,b)=>a>b?1:-1
      );
  }
  

</script>
<style scoped>
.txt-color {
  color: green; /*changes the text color*/
  background-color: blue; /*changes the text background color*/
}
</style>